import { React, useState, useEffect } from 'react';
import {
  Button,
  ButtonSet,
  Slider,
  Toggle,
  Tooltip,
} from 'carbon-components-react';

import { FormattedMessage } from 'react-intl';
import Cookies from 'js-cookie';
import Helmet from 'react-helmet';
import emailjs from 'emailjs-com';

import './Widget.scss';
import { segmentTracking } from '../lib/tracker';
import NoteDrawer from './NoteDrawer/NoteDrawer';
import Footnote from './Footnote/Footnote';
import Thanks from './Thanks/Thanks';
import Paragraph from './Paragraph/Paragraph';
import { estimatedPrice } from '../services/price-calculation';
import { scrollTo } from '../services/smoothScroll.js';
import { formatter } from '../services/formatter';
import { SPREAD20 } from '../constants/spread';
import * as EMAIL_JS from '../constants/emailJS';
import * as URX_FORM from '../constants/urx-form';

import bpList from '../services/bpList.json';

// Cookies.set('urxdcq', '');

function Widget() {
  const [employees, setEmployees] = useState(1000);
  const [servers, setServers] = useState(200);
  const [lowerPrice, setLowerPrice] = useState(0);
  const [higherPrice, setHigherPrice] = useState(0);
  const [urxLoaded, setUrxLoaded] = useState(false);
  const [formComplete, setFormComplete] = useState(false);
  const [ndr, setNdr] = useState(true);

  const [BPTitle, setBPTitle] = useState('Contact IBM Business Partner');

  const maxEmployees = 5000;
  const maxServers = 1000;

  const GETDATE = `${Date().toLocaleString()}`;

  const CloudPrem = 'SIEM on Cloud (SaaS)';

  const [drawerOpen, setDrawerOpen] = useState(false);

  window.urxEnvironment = 'production';
  window.onUrxFormSubmit = (params) => {
    console.log(params);

    let pcountry = params.country;
    let pstate = params.state;
    let mailinglist = EMAIL_JS.SEND_TO;

    // AUSTRALIA Mail routing
    if (pcountry === 'AU') {
      mailinglist = EMAIL_JS.AUSTRALIA_MAILTO; // Sadhana.A.D@ibm.com
    }
    // INDIA Mail routing
    if (pcountry === 'IN') {
      mailinglist = EMAIL_JS.INDIA_MAILTO; // kunshyam@in.ibm.com
    }
    // SINGAPORE Mail routing
    if (pcountry === 'SG') {
      mailinglist = EMAIL_JS.SINGAPORE_MAILTO; // Surabhi.Shrivastava@ibm.com
    }
    // US Mail routing
    if (pcountry === 'US') {
      if (
        pstate === 'AK' ||
        pstate === 'AZ' ||
        pstate === 'CO' ||
        pstate === 'HI' ||
        pstate === 'ID' ||
        pstate === 'NV' ||
        pstate === 'OR' ||
        pstate === 'WA' ||
        pstate === 'WY' ||
        pstate === 'GU' ||
        pstate === 'UM' ||
        pstate === 'AS'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_ONE; // Kendall.Graham@ibm.com
      }
      if (pstate === 'CA') {
        mailinglist = EMAIL_JS.US_MAILTO_TWO; // Reggie.Greer@ibm.com
      }
      if (
        pstate === 'IA' ||
        pstate === 'KS' ||
        pstate === 'MN' ||
        pstate === 'MO' ||
        pstate === 'MT' ||
        pstate === 'NE' ||
        pstate === 'NM' ||
        pstate === 'ND' ||
        pstate === 'OK' ||
        pstate === 'SD'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_THREE; // ccrook@us.ibm.com
      }
      if (pstate === 'TX') {
        mailinglist = EMAIL_JS.US_MAILTO_FOUR; // ericjohnson1@ibm.com
      }
      if (
        pstate === 'AL' ||
        pstate === 'AR' ||
        pstate === 'FL' ||
        pstate === 'LA' ||
        pstate === 'MS' ||
        pstate === 'PR' ||
        pstate === 'VI'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_FIVE; // Marlena.Matthews@ibm.com
      }

      if (
        pstate === 'GA' ||
        pstate === 'KY' ||
        pstate === 'NC' ||
        pstate === 'SC' ||
        pstate === 'OH' ||
        pstate === 'WV'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_SIX; // Gregory.Devieux@ibm.com
      }
      if (
        pstate === 'FED' ||
        pstate === 'DC' ||
        pstate === 'MD' ||
        pstate === 'VA' ||
        pstate === 'TN'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_SEVEN; // maxwell.watkins@ibm.com
      }
      if (pstate === 'NY') {
        mailinglist = EMAIL_JS.US_MAILTO_EIGHT; // Adib.Chowdury@ibm.com
      }
      if (pstate === 'IL' || pstate === 'WI') {
        mailinglist = EMAIL_JS.US_MAILTO_NINE; //alicia.brandon@us.ibm.com
      }
      if (
        pstate === 'CT' ||
        pstate === 'ME' ||
        pstate === 'MA' ||
        pstate === 'NH' ||
        pstate === 'RI' ||
        pstate === 'VT'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_TEN; // Shawn.Reynolds@ibm.com
      }
      if (
        pstate === 'IN' ||
        pstate === 'MI' ||
        pstate === 'PA' ||
        pstate === 'MH' ||
        pstate === 'UT' ||
        pstate === 'MP' ||
        pstate === 'DE'
      ) {
        mailinglist = EMAIL_JS.US_MAILTO_ELEVEN; // ozehmer@ibm.com
      }
    }

    // console.log('mailinglist: ', pcountry, pstate, mailinglist);

    // Email
    var templateParams = {
      employees: employees,
      servers: servers,
      price: `${formatter(lowerPrice)} - ${formatter(higherPrice)}`,
      ndr: ndr,
      CloudPrem: CloudPrem,
      state: params.state,
      country: params.country,
      Q_QRADAR_BP: params.CQ.Q_QRADAR_BP,
      Q_MAIL_CONSENT: params.CQ.Q_MAIL_CONSENT,
      jobTitle: params.jobTitle,
      feLog: params.feLog,
      getdate: GETDATE,
      message: params.CQ.Q_HELP,
      SEND_TO: mailinglist,
      SEND_CC: EMAIL_JS.SEND_CC,
      SEND_BCC: EMAIL_JS.SEND_BCC,
    };
    // console.log('templateParams: ', templateParams);
    emailjs
      .send(
        EMAIL_JS.SERVICE_ID,
        EMAIL_JS.TEMPLATE_ID,
        templateParams,
        EMAIL_JS.USER_ID,
      )
      .then(
        (result) => {
          console.log('SUCCESS: ', result);
        },
        (error) => {
          console.log('FAILED: ', error);
        },
      );
  };

  window.onUrxFormSubmitSuccess = () => {
    setFormComplete(!formComplete);
  };

  useEffect(() => {
    updatePrice();
  }, [employees, servers, ndr]);

  useEffect(() => {
    setServers(updateServers());
  }, [employees]);

  const setBpField = () => {
    const bpId = new URLSearchParams(window.location.search).get('bpid');

    if (bpId) {
      const businessPartner = bpList.find((bp) => bp.companyId === bpId)
        ?.bpName;

      if (businessPartner) {
        const bpField = document.querySelector('#Q_QRADAR_BP');
        bpField.value = businessPartner;
        bpField.setAttribute('disabled', 'disabled');
        setBPTitle(BPTitle + ': ' + businessPartner);
      }
    }
  };

  function getLocaleFromUrl() {
    // const url =
    // 'https://www.ibm.com/sg-en/products/hosted-security-intelligence/pricing';
    // const match = url.match(/\/([a-z]{2}-[a-z]{2})\//i);

    const match = window.location.href.match(/\/([a-z]{2}-[a-z]{2})\//i);

    if (match && match[1]) {
      console.log(' match[1]' + match[1]);
      return match[1];
    } else {
      return 'us-en';
    }
  }

  const setCookie = () => {
    // const bpconsent = params.CQ.Q_MAIL_CONSENT || 'false'; // urx-form > Checkbox bp consent
    // const preferred_bp = params.CQ.Q_QRADAR_BP; // urx-form > Preferred Business Partner

    Cookies.set(
      'urxdcq',
      JSON.stringify({
        source: URX_FORM.FORM_ID,
        // One field to provide all values (stringify)
        dcq: {
          Q_QRDATA:
            'Employees:' +
            employees +
            '|Servers:' +
            servers +
            '|NDR:' +
            ndr +
            '|Delivery Option: SIEM on Cloud SaaS|Estimated costs:' +
            formatter(lowerPrice) +
            '-' +
            formatter(higherPrice),
          Q_ASSET_URL: window.location.href, // ISC - Asset URL
          Q_ASSET_NAME: 'IBM QRadar SIEM Estimator', // ISC - Asset Name
        },
      }),
    );
    console.log(Cookies.get('urxdcq'));
  };

  useEffect(() => {
    if (urxLoaded) {
      window['renderUrxWidget'](
        URX_FORM.INSTANCE_ID,
        URX_FORM.FORM_ID,
        getLocaleFromUrl(),
        {
          column: 3,
          theme: 'light',
          singleStep: true,
          triggerManually: false,
        },

        () => {},
      );
      setTimeout(setBpField, 3100);
    } else {
      // wait until renderUrxWidget is defined, then update state
      (async () => {
        while (typeof window['renderUrxWidget'] === 'undefined') {
          await new Promise((resolve) => setTimeout(resolve, 3000)).then(() => {
            setUrxLoaded(true);
          });
        }
      })();
    }
  }, [urxLoaded]);

  const updateServers = () => {
    return Math.round(employees / 10) || 1;
  };

  const updatePrice = async () => {
    let resLower = await estimatedPrice(
      employees,
      servers,
      1 - SPREAD20,
      ndr,
      false, // not onPrem calc
      true,
    );
    let resHigher = await estimatedPrice(
      employees,
      servers,
      1 + SPREAD20,
      ndr,
      false, // not onPrem calc
      false,
    );
    if (resLower === resHigher) {
      setLowerPrice(resHigher);
      setHigherPrice(resHigher * 1.2);
    } else {
      setLowerPrice(resLower);
      setHigherPrice(resHigher);
    }
  };

  const scrollToForm = () => {
    document.getElementById('urx_row').style.display = 'flex';
    scrollTo(URX_FORM.INSTANCE_ID);
  };

  return (
    <div
      className="Widget ibm-widget-qradar"
      style={{ backgroundColor: '#FFF!important' }}>
      <Helmet>
        {/* <link
          rel="stylesheet"
          href="//1.www.s81c.com/common/v18/css/www.css"
          media="all"
        /> */}
        <link
          href="//1.www.s81c.com/common/v19a/css/www.css"
          rel="stylesheet"
        />
        <style>
          {`

        /* needed for sticky effect on stage */
        #ibm-top {
          overflow: visible !important;
        }

        .urx-form-container .form-block .form-heading h1 {
          display: none !important;
        }
        .urx-form-container .input-fields-container .field-container.Q_MAIL_CONSENT-container {
          flex: 0 0 100%!important;
          max-width: 100%!important;
      }
.ibm-widget-qradar .bx--combo-box.bx--list-box--disabled.bx--list-box--warning .bx--list-box__field, .ibm-widget-qradar .bx--combo-box.bx--list-box--disabled.bx--list-box[data-invalid] .bx--list-box__field, .ibm-widget-qradar .bx--combo-box.bx--list-box--warning .bx--list-box__field, .ibm-widget-qradar .bx--combo-box.bx--list-box[data-invalid] .bx--list-box__field, .ibm-widget-qradar .bx--combo-box .bx--list-box__field {
    padding: 0 3rem 0 1rem!important;
    width:100%;
}
#content {
  height:500px;
  width:calc(100% - 174px);
  padding:10px;
  border:1px solid green;
  margin:0;
  float:right;
  margin-top:5px;
}
#footer {
  height:200px;
  border:1px solid orange;
  background-color:#ddd;
}

.clear {
  clear:both;
}

.label-servers-link {
  background-color: inherit;
  border: none;
  cursor: pointer;
  color: #0f62fe;
  font-weight: 200;
  position: relative;
  font-size:.8rem
}
.ibm-widget-qradar .bx--tooltip__label {
  display:inline!important;
}

/* Sticky our navbar on window scroll */
#stickyNav {
  position: sticky;
  top: 9%;
  justify-content: flex-start;
  min-width: 18rem;

}

#signUpForm {
    margin: -3rem!important;
}
#QBand .bx--tooltip__label,
#servers-label {
  font-size:1rem;
}
.productive-heading-04 h3{display:none!important;}
p.ibm-padding-bottom-0 {
  font-weight:200!important;
  line-height:1.5!important;
  font-size: 1rem!important;
}
.form-heading-container a {
  font-size:inherit!important;
}
.ibm-widget-qradar ul {
  list-style: circle;
  margin-left:15px;
  font-size: 1.2rem;
}
.ibm-widget-qradar ul li {
  padding-bottom:5px;
}

#urx_row,
#__footnote_row,
#__hr_row_one, #hr_row_two {
  display:none;
}
.new-line {
  white-space: pre-line;
}
.ibm-widget-qradar .bx--inline-notification--info {
  background: #EDF5FF;
  color: #222;
}

.flex-container{
	width: 100%!important;
	min-height: 380px!important;
	margin: 0 auto!important;
	display: -webkit-flex!important; /* Safari */		
	display: flex!important; /* Standard syntax */

}
.flex-container .column{
	padding: 20px 20px 10px 20px!important;
  border:3px solid transparent;
	-webkit-flex: 1!important; /* Safari */
	-ms-flex: 1!important; /* IE 10 */
	flex: 1!important; /* Standard syntax */
}
.flex-container .column.selected{
	border:3px solid #1062FE;
  background-color: #1062FE;
  color:white;
}
.flex-container .column.selected::after{
  content: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='50' zoomAndPan='magnify' viewBox='0 0 37.5 37.499999' height='50' preserveAspectRatio='xMidYMid meet' version='1.0'%3E%3Cdefs%3E%3CclipPath id='id1'%3E%3Cpath d='M 1.875 1.875 L 35.625 1.875 L 35.625 35.625 L 1.875 35.625 Z M 1.875 1.875 ' clip-rule='nonzero'/%3E%3C/clipPath%3E%3C/defs%3E%3Cg clip-path='url(%23id1)'%3E%3Cpath fill='%23ffffff' d='M 18.746094 35.621094 C 9.441406 35.621094 1.871094 28.050781 1.871094 18.746094 C 1.871094 9.441406 9.441406 1.871094 18.746094 1.871094 C 28.050781 1.871094 35.621094 9.441406 35.621094 18.746094 C 35.621094 28.050781 28.050781 35.621094 18.746094 35.621094 Z M 18.746094 3.714844 C 10.457031 3.714844 3.710938 10.457031 3.710938 18.746094 C 3.710938 27.035156 10.457031 33.777344 18.746094 33.777344 C 27.035156 33.777344 33.777344 27.035156 33.777344 18.746094 C 33.777344 10.457031 27.035156 3.714844 18.746094 3.714844 Z M 18.746094 3.714844 ' fill-opacity='1' fill-rule='nonzero'/%3E%3C/g%3E%3Cpath fill='%23ffffff' d='M 14.808594 25.984375 C 14.574219 25.984375 14.335938 25.894531 14.15625 25.714844 L 9.390625 20.949219 C 9.03125 20.589844 9.03125 20.007812 9.390625 19.648438 C 9.753906 19.289062 10.335938 19.289062 10.695312 19.648438 L 14.808594 23.761719 L 26.796875 11.773438 C 27.15625 11.414062 27.738281 11.414062 28.097656 11.773438 C 28.457031 12.132812 28.457031 12.71875 28.097656 13.078125 L 15.460938 25.714844 C 15.28125 25.894531 15.042969 25.984375 14.808594 25.984375 Z M 14.808594 25.984375 ' fill-opacity='1' fill-rule='nonzero'/%3E%3C/svg%3E ");
  float:right;
  margin-top:-30px;
}

.flex-container .column:hover{
  border:3px solid #1062FE;
}
.bx--visually-hidden {display:none!important;}
@media only screen and (max-width: 1055px) {
  #stickyNav {margin-top:30px;}

    .bx--content-switcher {
      max-width: 38rem;
    }
    .ibm-widget-qradar .bx--inline-notification {
      display:block
    }

    .ibm-widget-qradar .bx--content-switcher-btn:first-child {
      border-right:0.0625rem solid #161616
    }
  }
  @media only screen and (max-width: 560px) {
  .ibm-widget-qradar .bx--content-switcher  {
    width: 20rem;
  }
}

`}
        </style>
        <script
          type="application/javascript"
          src="https://www.ibm.com/account/ibmidutil/widget/js/loader.js"></script>
        <script
          type="application/javascript"
          src="https://www.ibm.com/account/ibmidutil/widget/js/main.js"></script>

        {/* <script type="application/javascript" src="https://wwwstage.ibm.com/account/ibmidutil/widget/js/loader.js"></script>
<script type="application/javascript" src="https://wwwstage.ibm.com/account/ibmidutil/widget/js/main.js"></script> */}
      </Helmet>
      {formComplete ? (
        <Thanks
          employees={employees}
          servers={servers}
          lowerPrice={lowerPrice}
          higherPrice={higherPrice}
          ndr={ndr}
          OnPrem={CloudPrem}
        />
      ) : (
        <div className="Widget__container" id="QRoCGrid">
          <div className="bx--grid">
            <div className="bx--row" style={{ padding: '2rem' }}>
              <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-16">
                <div className="bx--row" id="QBand">
                  <div className="bx--col-lg-4 bx--col-md-8 bx--col-sm-4">
                    <Paragraph
                      content="Estimate your solution size"
                      idFM="widget.scoping-Q"
                      bold={true}
                    />
                  </div>
                  <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4">
                    <div className="bx--row">
                      <div className="bx--col-lg-16">
                        <h3
                          className="ibm-duo-text-promo__headline bx--type-expressive-heading-04 bx--type-semibold ibm-mb-3 ibm-pb-0 ibm-textcolor-gray-90"
                          style={{
                            lineHeight: '1.5',
                            fontWeight: '400',
                            fontSize: '28px',
                            paddingBottom: '30px',
                          }}>
                          Find the right size for your solution and estimate
                          your QRadar {CloudPrem} price.
                        </h3>

                        <strong>Scoping Questions</strong>
                        <Paragraph
                          content="By providing the size of your organization, we can generate a rough QRadar price estimate based on the needs of other clients of similar size. This is only an approximation, and a specialist will help you get a customized quote."
                          idFM="widget.first-paragraph"
                        />
                      </div>
                    </div>
                    <div className="bx--row" style={{ paddingTop: '45px' }}>
                      <div className="bx--col-lg-16 bx--col-md-4 bx--col-sm-4">
                        <Tooltip
                          onChange={() => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'QRadar Landing Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'Employees tooltip',
                              location: 'Estimator',
                            });
                          }}
                          direction="right"
                          tabIndex={0}
                          triggerText="Total Workstations or Employees">
                          <p
                            style={{
                              backgroundColor: '#262626',
                              lineHeight: '1.5',
                              margin: '-16px',
                              padding: '15px',
                              color: '#FFF',
                              textAlign: 'left',
                              Border: '1px solid #262626',
                            }}>
                            If your organization has more than 5000 employees
                            please
                            <p
                              style={{
                                Padding: '20px',
                              }}>
                              &nbsp;
                            </p>
                            <a
                              onClick={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'QRadar Landing Page',
                                  object: 'Pricing page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Contact us tooltip',
                                  location: 'Estimator',
                                });
                              }}
                              target="_self"
                              data-ibm-contact="scheduler-link"
                              href="javascript:void(0)"
                              className="ibm-btn-pri ibm-duo-btn-cta ibm-duo-u--link-icon"
                              style={{
                                backgroundColor: '#0062ff',
                                color: '#FFF',
                                textDecoration: 'none',
                                border: '#0062ff',
                                padding: '2px 4px',
                                lineHeight: '1.8',
                              }}>
                              Contact us
                            </a>
                          </p>
                        </Tooltip>
                        {/* {!InfoPrem && <SliderSkeleton />} */}

                        <Slider
                          id="employees"
                          className="Widget__input-number"
                          min={1}
                          max={maxEmployees}
                          value={employees}
                          // onChange={() => setEmployees(value)}
                          onChange={({ value }) => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'QRadar Landing Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'Employees Slider',
                              location: 'Estimator',
                            });
                            setEmployees(value);
                            setCookie();
                          }}
                        />
                      </div>
                    </div>
                    <hr className="Widget__custom-hr" />
                    <div className="bx--row">
                      <div className="bx--col-lg-16 bx--col-md-4 bx--col-sm-4">
                        <Slider
                          id="servers"
                          className="Widget__input-number"
                          min={1}
                          max={maxServers}
                          value={servers}
                          labelText={
                            <p>
                              <FormattedMessage
                                id="widget.total-servers"
                                defaultMessage="Total Servers in the Environment (optional) "
                              />
                              <button
                                className="label-servers-link"
                                onClick={() => {
                                  segmentTracking('CTA Clicked', {
                                    pageTitle: 'QRadar Landing Page',
                                    object: 'Pricing page',
                                    resultValue: 'CTA clicked',
                                    CTA: 'More Information Drawer',
                                    location: 'Estimator',
                                  });
                                  setDrawerOpen(true);
                                }}>
                                More Information
                              </button>
                            </p>
                          }
                          onChange={({ value }) => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'QRadar Landing Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'Total servers',
                              location: 'Estimator',
                            });
                            setServers(value);
                            setCookie();
                          }}
                        />

                        <hr className="Widget__custom-hr" />

                        <Tooltip
                          onChange={() => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'QRadar Landing Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'NDR tooltip',
                              location: 'Estimator',
                            });
                          }}
                          direction="right"
                          tabIndex={0}
                          triggerText="Include QRadar NDR to monitor network data and expose hidden security threats">
                          <p
                            style={{
                              backgroundColor: '#262626',
                              lineHeight: '1.5',
                              margin: '-16px',
                              padding: '15px',
                              color: '#FFF',
                              textAlign: 'left',
                              Border: '1px solid #262626',
                            }}>
                            To learn more about QRadar Network Detection and
                            Response visit &nbsp;
                            <a
                              onClick={() => {
                                segmentTracking('CTA Clicked', {
                                  pageTitle: 'QRadar Landing Page',
                                  object: 'Pricing page',
                                  resultValue: 'CTA clicked',
                                  CTA: 'Qradar NDR',
                                  location: 'Estimator',
                                });
                              }}
                              rel="noreferrer"
                              target="_blank"
                              style={{ color: '#4589ff' }}
                              href="https://www.ibm.com/qradar/security-qradar-ndr">
                              IBM® QRadar® NDR
                            </a>
                          </p>
                        </Tooltip>
                        <Toggle
                          // size="sm"
                          labelA="No"
                          labelB="Yes"
                          defaultToggled
                          id="ndr"
                          onChange={() => {
                            segmentTracking('CTA Clicked', {
                              pageTitle: 'QRadar Landing Page',
                              object: 'Pricing page',
                              resultValue: 'CTA clicked',
                              CTA: 'NDR toggle',
                              location: 'Estimator',
                            });
                            setNdr(!ndr);
                            setCookie();
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="bx--col-lg-4 bx--col-md-8 bx--col-sm-4">
                    <div id="stickyNav" className="sticky bx--row">
                      <div
                        className="Widget__sticky-nav"
                        style={{ paddingRight: '20px' }}>
                        <p
                          idFM="widget.estimated-cost"
                          className="Widget__ibm-type-e">
                          Estimated monthly cost{' '}
                          <sup className="Widget__sup">1</sup>
                        </p>
                        <p className="Widget__prices">
                          {`${formatter(lowerPrice)} - ${formatter(
                            higherPrice,
                          )}*`}
                        </p>
                        <br />* Prices shown do not include tax.
                        <ButtonSet className="Widget__stack-button" stacked>
                          {/* <Button onClick={() => scrollToForm()}> */}
                          <Button
                            onClick={() => {
                              segmentTracking('CTA Clicked', {
                                pageTitle: 'QRadar Landing Page',
                                object: 'Pricing page',
                                resultValue: 'CTA clicked',
                                CTA: 'Request a quote now',
                                location: 'Estimator',
                              });
                              scrollToForm();
                              setCookie();
                            }}>
                            <FormattedMessage
                              id="widget.get-quote"
                              defaultMessage="Request a quote now"
                            />
                          </Button>
                        </ButtonSet>
                      </div>
                      <div style={{ marginLeft: '20px', marginTop: '20px' }}>
                        <Footnote
                          numNote={1}
                          textNote="Estimated costs are not a formal offer from IBM or an IBM Business Partner.  Certain factors such as QRadar configuration, add-ons, and discounts may affect estimated costs. IBM Business Partners set and provide their own IBM SIEM pricing and are not bound by the provided estimate."
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="bx--row" id="urx_row">
                  <div
                    className="bx--col-lg-4 bx--col-md-8 bx--col-sm-4"
                    style={{ paddingTop: '30px' }}>
                    <p style={{ fontWeight: 'bold' }}>
                      <FormattedMessage
                        id="widget.ContactBP"
                        defaultMessage={BPTitle}
                      />
                    </p>
                  </div>
                  <div className="bx--col-lg-8 bx--col-md-8 bx--col-sm-4">
                    <div
                      style={{ paddingTop: '80px', paddingBottom: '80px' }}
                      id="urx-form"></div>
                  </div>
                </div>

                <hr className="Widget__custom-hr" id="hr_row_two" />
              </div>
            </div>
          </div>
        </div>
      )}
      <NoteDrawer drawerOpen={drawerOpen} setDrawerOpen={setDrawerOpen} />
    </div>
  );
}

export default Widget;
